const CrossOriginImg = (
  props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
) => <img crossOrigin="anonymous" {...props} />;

export default CrossOriginImg;
